import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaUser,
  FaTelegramPlane,
  FaMoneyBillWave,
  FaComment,
} from "react-icons/fa";

// Анимация заголовка
const titleVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Анимация полей формы
const inputVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { duration: 0.4, delay: i * 0.15, ease: "easeOut" },
  }),
};

// Анимация попапа
const popupVariants = {
  hidden: { opacity: 0, scale: 0.7 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.3, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    scale: 0.7,
    transition: { duration: 0.3, ease: "easeOut" },
  },
};

function Contact() {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    currentIncome: "",
    desiredIncome: "",
    whyYou: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPopupOpen(true);
    setFormData({
      name: "",
      contact: "",
      currentIncome: "",
      desiredIncome: "",
      whyYou: "",
    });
  };

  return (
    <section className="contact" id="contact">
      <motion.div
        className="contact__content"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.5 }}
      >
        <motion.h2
          className="contact__title"
          variants={titleVariants}
          initial="hidden"
          whileInView="visible"
        >
          УКЛАДИ УГОДУ З <span>АКУЛАМИ AFFILIATE РИНКУ</span>
        </motion.h2>
        <motion.p
          className="contact__subtitle"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
        >
          та отримуй найкраще на affiliate-ринку
        </motion.p>

        <motion.div
          className="contact__info"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }}
        >
          <p className="contact__label">EMAIL</p>
          <p className="contact__email">DOMAIN@gmail.com</p>
        </motion.div>
      </motion.div>

      <form className="contact__form" onSubmit={handleSubmit}>
        <div className="contact__row">
          {[
            {
              name: "name",
              placeholder: "Ваше ім'я",
              icon: <FaUser />,
              maxLength: 25,
            },
            {
              name: "contact",
              placeholder: "Номер телефону / нік Telegram",
              icon: <FaTelegramPlane />,
              maxLength: 35,
            },
          ].map((field, index) => (
            <motion.div
              key={field.name}
              className="contact__input-wrapper"
              variants={inputVariants}
              initial="hidden"
              whileInView="visible"
              custom={index}
              viewport={{ once: false, amount: 0.8 }}
            >
              <input
                type="text"
                name={field.name}
                placeholder={field.placeholder}
                className="contact__input2"
                value={formData[field.name]}
                onChange={handleChange}
                required
                maxLength={field.maxLength}
              />
              <span className="contact__icon">{field.icon}</span>
            </motion.div>
          ))}
        </div>

        {[
          {
            name: "currentIncome",
            placeholder: "Чим ти зараз займаєшся та який у тебе дохід?",
            icon: <FaMoneyBillWave />,
            maxLength: 150,
          },
          {
            name: "desiredIncome",
            placeholder: "На який дохід хочеш вийти?",
            icon: <FaMoneyBillWave />,
            maxLength: 150,
          },
        ].map((field, index) => (
          <motion.div
            key={field.name}
            className="contact__input-wrapper"
            variants={inputVariants}
            initial="hidden"
            whileInView="visible"
            custom={index + 2}
            viewport={{ once: false, amount: 0.8 }}
          >
            <input
              type="text"
              name={field.name}
              placeholder={field.placeholder}
              className="contact__input"
              value={formData[field.name]}
              onChange={handleChange}
              required
              maxLength={field.maxLength}
            />
            <span className="contact__icon">{field.icon}</span>
          </motion.div>
        ))}

        <motion.div
          className="contact__input-wrapper"
          variants={inputVariants}
          initial="hidden"
          whileInView="visible"
          custom={4}
          viewport={{ once: false, amount: 0.8 }}
        >
          <textarea
            name="whyYou"
            placeholder="Чому саме ви?"
            className="contact__textarea"
            value={formData.whyYou}
            onChange={handleChange}
            required
            maxLength={400}
          ></textarea>
          <span className="contact__icon">
            <FaComment />
          </span>
        </motion.div>

        <motion.button
          type="submit"
          className="contact__button"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, ease: "easeOut", delay: 0.6 }}
        >
          ПРИЄДНАТИСЬ ДО НАС
        </motion.button>
      </form>

      {/* Попап с анимацией */}
      <AnimatePresence>
        {isPopupOpen && (
          <>
            <motion.div
              className="popup-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            />
            <motion.div
              className="popup"
              variants={popupVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <div className="popup__content">
                <p>Ваше повідомлення надіслано!</p>
                <button
                  onClick={() => setPopupOpen(false)}
                  className="popup__close"
                >
                  OK
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </section>
  );
}

export default Contact;
